import './style.scss';
import Swiper from 'swiper';
import 'swiper/swiper.scss';
import {EffectFade, Autoplay, Navigation, Pagination} from 'swiper/modules';
import 'swiper/modules/effect-fade.css';

export function company_history_block() {
    const blocks = document.querySelectorAll('.company_history_block');
    if (!blocks.length) return;

    blocks.forEach(block => {
        const swiper = new Swiper(block.querySelector('.company-history-swiper'), {
            slidesPerView: 1,
            spaceBetween: 40,
            loop: true,
            mousewheel: true,
            effect: 'fade',
            speed: 1000,
            modules: [EffectFade, Autoplay, Navigation, Pagination],
            fadeEffect: {crossFade: true},
            autoplay: {delay: 10000, disableOnInteraction: false},

            navigation: {
                nextEl: block.querySelector('.swiper-button-next'),
                prevEl: block.querySelector('.swiper-button-prev'),
            },

            pagination: {
                el: block.querySelector('.pagination-wrapper'),
                type: 'fraction',
                renderFraction: (currentClass, totalClass) => `
        <div class="gallery-pill">
          <span class="${currentClass}">1</span>
          <span class="sep"> / </span>
          <span class="${totalClass}">1</span>
        </div>
      `,
                formatFractionCurrent: (n) => String(n),
                formatFractionTotal: (n) => String(n),
            },
        });

        // Initialize stopped
        swiper.autoplay.stop();

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    swiper.autoplay.start();
                } else {
                    swiper.autoplay.stop();
                }
            });
        }, {
            threshold: 0.1 // Trigger when 10% of the block is visible
        });

        observer.observe(block);

        // Animate fraction change (pulse the current number)
        const pill = block.querySelector('.pagination-wrapper .gallery-pill');
        const triggerAnim = () => {
            if (!pill) return;
            pill.classList.remove('paging-anim'); // restart animation if clicking fast
            // force reflow to restart CSS animation reliably
            // eslint-disable-next-line no-unused-expressions
            pill.offsetHeight;
            pill.classList.add('paging-anim');
            setTimeout(() => pill.classList.remove('paging-anim'), 400); // > .35s
        };

        swiper.on('slideChangeTransitionStart', triggerAnim);
        // optional: also animate on autoplay loop edge cases
        swiper.on('loopFix', triggerAnim);
    });
}
